import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
// mock
import { API_URL } from '../../api';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
export const DeleteModal = ({ deleteModal, handleDeleteModal, deleteId, setContact, setPlus, plus }) => {
  // ** Function to delete single role
  const deleteContact = async (id) => {
    await axios
      .delete(`${API_URL}/api/messages/${id}`, {
        headers: {
          Authorization: cookies.get('TOKEN'),
        },
      })
      .then(
        () => {
          setPlus(plus + 1);
        },
        axios
          .get(`${API_URL}/api/messages/`)
          .then((res) => {
            handleDeleteModal();
            setContact(res?.data);
            toast.success(res?.data?.message || 'Contact Deleted Successfully.');
          })
          .catch((error) => {
            console.log(error);
            handleDeleteModal();
            toast.error(err?.response?.data?.message || 'Something went wrong');
          })
      );
  };

  return (
    <Dialog open={deleteModal}>
      <DialogTitle>Delete Contact</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1">Are you sure? </Typography>
        <Typography variant="subtitle1">Once deleted data cannot be recovered.</Typography>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          type="submit"
          style={{ fontFamily: 'Inter', minWidth: '90px' }}
          onClick={() => {
            deleteContact(deleteId);
          }}
        >
          Confirm
        </Button>
        <Button
          variant="contained"
          type="submit"
          style={{ fontFamily: 'Inter', minWidth: '90px' }}
          onClick={handleDeleteModal}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
